@use '../../../../design-tokens/border-radius/border-radius' as *;
@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .tooltipRoot {
    position: absolute;
    top: 40px;
    width: 1px;
    height: 1px;
  }

  .tooltipLabelContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 160px;
    padding: 12px;
    box-sizing: border-box;

    &.multiAsset {
      width: 259px;
    }

    &.withPercent {
      width: 200px;
    }
  }

  .dateRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .dateLabel {
    @include typography-v2-body-xs;
    color: var(--text-soft);
    flex: 1 0 0;
  }

  .tooltipRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .tooltipLegend {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  .tooltipLegendColor {
    width: 8px;
    height: 8px;
    @include border-radius-full;

    &.dashed {
      width: 12px;
      height: 1px;
      background: none;
      border-radius: unset;
    }
  }

  .tooltipLabel {
    @include typography-v2-body-xs;
    color: var(--text-default);
  }

  .tooltipValue {
    @include typography-v2-body-xs;
    font-family: var(--font-roboto-mono);
    text-align: right;
    flex-shrink: 0;
    color: var(--text-default);
  }

  .tooltipValueArea {
    text-align: right;

    &.withPercentChange {
      display: flex;
      align-items: center;
      gap: 0.5em;
    }
  }

  .percentChange {
    @include typography-v2-body-xs;
    font-family: var(--font-roboto-mono);
    white-space: nowrap;
  }

  .positive {
    color: var(--text-success);
  }

  .negative {
    color: var(--text-critical);
  }

  .chartTooltip {
    pointer-events: none;
    padding: 0;
  }
}
